import React from 'react'
import'./City.css'
import {Link}from 'react-router-dom'
function City() {


    
  return (
    <div className='city'>
      <h1 className='city-h1'>Popular localities in and around Ranchi</h1>



         <div className='area'>
         <Link style={{textDecoration: 'none'}} to="/foods"><div className='area-card'>
        <h3 className='name'>Lalapur</h3>
        <p className='para'>390 places</p>
      </div> </Link>
      
      <Link style={{textDecoration: 'none'}} to="/foods">
      <div className='area-card'>
        <h3 className='name'>Hindpiri</h3>
        <p className='para'>190 places</p>
      </div>
      </Link>
      <Link to="/foods" style={{textDecoration: 'none'}}>
      <div className='area-card'>
        <h3 className='name'>kanka</h3>
        <p className='para'>100 places</p>
      </div>
      </Link>
      </div>
    </div>
  )
}

export default City
